import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import * as service from '../services';
import { useSetupAderenciaDePrecosStore } from '../SetupAderenciaDePrecos.store';

export const useGetAderenciaUploadedList = () => {
    const {
        setAderenciaData,
    } = useSetupAderenciaDePrecosStore();

    const getAderenciaTableData = async () => {
        const resp = await service.getAderenciaUploadsList();
        return resp;
    };

    const {
        data, refetch,
    } = useQuery(
        {
            queryKey: ['get-setup-aderencia-uploads'],
            queryFn: getAderenciaTableData,
            retry: false,
            onSuccess: (data) => {
                setAderenciaData(data);
            },
            onError: () => {
                setAderenciaData({ data: { content: [] } });
            },
        },
    );

    const setupData = useMemo(() => data, [data]);

    return {
        aderenciaData: setupData,
        getAderenciaRefetch: refetch,
    };
};
